import React from 'react';

import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import MailOutlined from '@ant-design/icons/MailOutlined';
import PhoneFilled from '@ant-design/icons/PhoneFilled';

import './HelpPage.less';

// First use of @ant-design/icons in src/ (already a dependency, v4.8.3). Deliberate:
// the repo has no phone/mail/clock/info SVG, and existing icons are brand assets that
// must not be edited. These icons inherit CSS `color`, so all theming lives in the LESS.
const CONTACT_METHODS = [
  {
    key: 'us',
    label: 'US',
    value: '(929) 357-5037',
    hint: 'Call or text',
    href: 'tel:+19293575037',
    ariaLabel: 'Call or text US support at (929) 357-5037',
    Icon: PhoneFilled,
  },
  {
    key: 'canada',
    label: 'Canada',
    value: '(647) 945-5457',
    hint: 'Call or text',
    href: 'tel:+16479455457',
    ariaLabel: 'Call or text Canada support at (647) 945-5457',
    Icon: PhoneFilled,
  },
  {
    key: 'email',
    label: 'Email',
    value: 'support@paritygo.com',
    hint: 'Send us a message',
    href: 'mailto:support@paritygo.com',
    ariaLabel: 'Email support at support@paritygo.com',
    Icon: MailOutlined,
  },
];

export const HelpPage = (props) => {
  const { theme } = props;

  window.document.title = `Help`;

  return (
    <section id="help-page" className={`help-page-${theme}`} aria-labelledby="help-page-heading">
      <div className="help-page-header">
        <div className="help-contact">
          <header className="help-contact-intro">
            <h1 className="help-contact-heading" id="help-page-heading">
              Need Help? We&apos;re Here for You.
            </h1>
            <p className="help-contact-subhead">Contact our support team for assistance.</p>
            <p className="help-contact-hours">
              <ClockCircleOutlined className="help-contact-hours-icon" aria-hidden="true" />
              <span>We’re available 8 AM – 10 PM, Monday through Sunday.</span>
            </p>
          </header>

          <h2 className="help-contact-methods-heading">Ways to reach us</h2>
          <ul className="help-contact-methods">
            {CONTACT_METHODS.map(({ key, label, value, hint, href, ariaLabel, Icon }) => {
              return (
                <li className={`help-contact-method help-contact-method-${key}`} key={key}>
                  <a className="help-contact-card" href={href} aria-label={ariaLabel}>
                    <span className="help-contact-card-icon" aria-hidden="true">
                      <Icon />
                    </span>
                    <span className="help-contact-card-body">
                      <span className="help-contact-card-label">{label}</span>
                      <span className="help-contact-card-value">{value}</span>
                      <span className="help-contact-card-hint">{hint}</span>
                    </span>
                  </a>
                </li>
              );
            })}
          </ul>

          <footer className="help-contact-footnotes">
            <InfoCircleOutlined className="help-contact-footnotes-icon" aria-hidden="true" />
            <div className="help-contact-footnotes-text">
              <p className="help-contact-disclaimer">For the fastest response, call or text our support line.</p>
              <p className="help-contact-disclaimer">
                For any mechanical emergencies outside of our support hours, please contact your after-hours contractor.
              </p>
            </div>
          </footer>
        </div>
      </div>
    </section>
  );
};
